import { Row, Col, Typography } from "antd";

import "./index.css";

const { Title } = Typography;

const TableHeader = ({ left, right, equal, title, noPadding, titleClass }) => (
  <Row align="middle" justify="space-between" gutter={[0, 50]}>
    <Col span={equal ? 8 : 6} xs={4}>
      {left}
    </Col>
    <Col span={equal ? 8 : 12} xs={16}>
      <Title className={`center ${titleClass || ""}`}>{title}</Title>
    </Col>
    <Col span={equal ? 8 : 6} xs={4}>
      <Row justify="end" align="middle" gutter={10}>
        <Col className={noPadding ? "" : "table-header-last-item"}>{right}</Col>
      </Row>
    </Col>
  </Row>
);

export default TableHeader;
